import { SEOProps } from "../types";
import { useEffect } from "react";

const BASE_TITLE = 'Ingenieria Meka Industrial';
const BASE_URL = 'https://www.ingenieriameka.com';

export function useSEO ({title, description, canonical} : SEOProps) {
    useEffect (() => {
        // titulo de la pestana
        document.title = `${title} `;
        // Meta description
    let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (metaDesc) metaDesc.content = description;

    // Canonical
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (link) link.href = canonical ?? BASE_URL;

    // Open Graph
    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.content = `${title} | ${BASE_TITLE}`;

    const ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDesc) ogDesc.content = description;

    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (ogUrl) ogUrl.content = canonical ?? BASE_URL;

  }, [title, description, canonical]);
}

